import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { Select } from '~/eds/src/components/Select/Select';
import { api } from '~/redux/api/createApi';
import { Nullable } from '~/types/Nullable';
import { PilotId } from '~/types/PilotId';

interface Props {
  value: Nullable<PilotId>;
  onChange: (updatedValue: Nullable<PilotId>) => void;
}

export const FieldSectionSelect = ({ value, onChange }: Props) => {
  const intl = useIntl();
  const { data = { results: [] }, isFetching: isLoading } =
    api.endpoints.getFieldSections.useQuery({
      limit: 1000,
    });

  const options = useMemo(
    () =>
      data.results.map((section) => ({
        label: section.label,
        value: section.id,
      })),
    [data],
  );

  return (
    <Select
      isLoading={isLoading}
      isMulti={false}
      name="select field section"
      options={options}
      placeholder={intl.formatMessage({
        id: 'FieldSectionSelect.placeholder',
        defaultMessage: 'Select field section',
        description: 'Placeholder text for field section selection',
      })}
      value={value}
      onChange={onChange}
    />
  );
};
